export { default } from './TeamChatTypingIndicator';
